module.exports = fox._r("images/join-block-image.jpg", __webpack_public_path__ + "images/join-block-image.jpg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/join-block-image.jpg
// module id = 979
// module chunks = 4